import React from 'react';
import { PageContainer } from 'components/shared/Page/PageContainer';
import {
  SalesCenterForm,
  SalesCenterRules,
  SalesCenterLayout,
  SalesCenterWorkflow,
  SalesCenterApiContainer,
} from 'modules/dealSheet';

export const DealSheetConfigurationPage = () => (
  <PageContainer title="Sales Center">
    <SalesCenterApiContainer>
      {({ listOfConfigs, config, onConfigureWorkflow, isLoading }) => (
        <SalesCenterLayout
          form={<SalesCenterForm />}
          rules={<SalesCenterRules workflow={config} />}
          workflow={
            <SalesCenterWorkflow
              isLoading={isLoading}
              listOfWorkflow={listOfConfigs}
              onConfigureWorkflow={onConfigureWorkflow}
            />
          }
        />
      )}
    </SalesCenterApiContainer>
  </PageContainer>
);
